// Iter 88o — Sidebar department row + empty right-pane, extracted from
// JobBoard.jsx. Both are dumb display components; parent owns state.

import { Briefcase, Building2, ChevronRight, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

export function DeptRow({ dept, selected, onClick, postings, selectedPostingId, onPickPosting }) {
  return (
    <div>
      <button onClick={onClick}
              data-testid={`dept-${dept.key}`}
              className={`w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-slate-50 dark:hover:bg-slate-800/60 transition ${
                selected ? "bg-indigo-50/70 dark:bg-indigo-950/40" : ""
              }`}>
        <Building2 className={`h-4 w-4 shrink-0 ${selected ? "text-indigo-600" : "text-slate-400"}`} />
        <span className={`flex-1 text-sm font-medium ${selected ? "text-indigo-900" : "text-slate-700"}`}>
          {dept.name}
        </span>
        <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium text-slate-600 tabular-nums"
              data-testid={`dept-${dept.key}-count`}>
          {selected && postings != null ? postings.length : (dept.open_postings || 0)}
        </span>
        <ChevronRight className={`h-4 w-4 shrink-0 transition ${selected ? "rotate-90 text-indigo-500" : "text-slate-300"}`} />
      </button>
      {selected && postings != null && postings.length > 0 && (
        <div className="bg-slate-50/60 dark:bg-slate-900/40 border-t border-slate-100 dark:border-slate-800">
          {postings.map((p) => (
            <button key={p.posting_id}
                    onClick={() => onPickPosting(p.posting_id)}
                    data-testid={`posting-${p.posting_id}`}
                    className={`w-full flex items-center gap-2 pl-10 pr-4 py-2 text-left hover:bg-white dark:hover:bg-slate-800 transition ${
                      selectedPostingId === p.posting_id ? "bg-white dark:bg-slate-800 shadow-sm" : ""
                    }`}>
              <div className="flex-1 min-w-0">
                <div className={`text-[13px] font-medium truncate ${
                  selectedPostingId === p.posting_id ? "text-indigo-900" : "text-slate-800"
                }`}>{p.title}</div>
                <div className="text-[10px] text-slate-500 truncate">
                  {p.status === "open" ? (
                    <span className="text-emerald-600">● Open</span>
                  ) : (
                    <span className="text-slate-400">○ Closed</span>
                  )}
                  {p.location && <> · {p.location}</>}
                </div>
              </div>
              <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium text-slate-600 tabular-nums">
                {p.resume_count || 0}
              </span>
            </button>
          ))}
        </div>
      )}
      {selected && postings != null && postings.length === 0 && (
        <div className="bg-slate-50/60 dark:bg-slate-900/40 border-t border-slate-100 dark:border-slate-800 px-10 py-3 text-[11px] text-slate-500 dark:text-slate-400">
          No postings yet in this department.
        </div>
      )}
    </div>
  );
}

export function EmptyRightPane({ onCreate, hasPostings }) {
  return (
    <div className="p-10 text-center" data-testid="job-board-empty-pane">
      <Briefcase className="mx-auto h-10 w-10 text-slate-300" />
      <h3 className="mt-3 font-heading text-base font-semibold text-slate-700">
        {hasPostings ? "Pick a posting from the sidebar" : "No postings yet"}
      </h3>
      <p className="mt-1 text-sm text-slate-500 max-w-md mx-auto">
        {hasPostings
          ? "Select a role on the left to review its resumes."
          : "Create your first posting to start collecting resumes for this department."}
      </p>
      {!hasPostings && (
        <Button onClick={onCreate} data-testid="job-board-empty-create" className="gap-2 mt-4">
          <Plus className="h-4 w-4" /> New posting
        </Button>
      )}
    </div>
  );
}
